export default __webpack_public_path__ + "static/media/mission.784c095c.png";